import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";


/**
 * Renders a button which, when selected, will redirect the page to the login prompt
 */
export const SignInButton = () => {
    const { instance } = useMsal();

    const handleLogin = (loginType) => {
        if (loginType === "redirect") {
            instance.loginRedirect(loginRequest).catch(e => {
                console.log(e);
            });
        }
    }
    return (
        <div variant="secondary" className="ml-auto btn btn-outline-secondary " onClick={() => handleLogin("redirect")}>Iniciar sesión</div>
    );
}